export const DamProdamIframeEvents = {
  HeightUpdate: 'heightUpdate',
};
